import { Injectable } from '@angular/core';
import { DefaultTestimonyApisModel } from '../../models/testify/testify';
import { DefaultTestimonyModel } from '../../view-models/testify';
import { Mapper } from '../mapper';

@Injectable({
    providedIn: 'root'
})
export class TestifyDefualtMapper implements Mapper<DefaultTestimonyApisModel, DefaultTestimonyModel>  {
    constructor(

    ) { }
    mapForm(param: DefaultTestimonyApisModel): DefaultTestimonyModel {
        return {
            reQID: param.reQ_ID,
            filingAS: param.filingAS,
            filingASDOCS: param.filingaS_DOCS ? param.filingaS_DOCS : 1,
            filingGroup: param.filingGroup,
            administrativeCourt: param.c_ID,
            blackNumberCase: param.seC_ID,
            suitBlackCode: param.suiT_BLACK_NO,
            suitBlackYear: param.suiT_BLACK_YEAR,
            suitID: param.suiT_ID,
            userSelected: param.userSelected,
            filesPermission : param.filesPermissions,
            pageCountPermissionPDf : param.pageCountPermissionPDf,
            suitTypeId:param.suitTypeId

        }
    }

    mapTo(param: DefaultTestimonyModel): DefaultTestimonyApisModel {
        return {
            reQ_ID: param.reQID,
            filingAS: param.filingAS,
            filingaS_DOCS: param.filingASDOCS,
            filingGroup: param.filingGroup,
            c_ID: param.administrativeCourt,
            seC_ID: param.blackNumberCase,
            suiT_BLACK_NO: param.suitBlackCode,
            suiT_BLACK_YEAR: param.suitBlackYear,
            suiT_ID: param.suitID,
            userSelected: param.userSelected,
            filesPermissions : param.filesPermission,
            pageCountPermissionPDf : param.pageCountPermissionPDf,
            suitTypeId:param.suitTypeId

        }
    }

} 